<template>
  <div id="app">
    <router-view />

   <!-- <van-tabbar route>
      <van-tabbar-item replace to="/ysj/home" icon="home-o">
        首页
      </van-tabbar-item>
      <van-tabbar-item replace to="/ysj/activity" icon="friends-o">
        活动
      </van-tabbar-item>
       <van-tabbar-item replace to="/ysj/myInfo" icon="user-o">
        我的
      </van-tabbar-item>
    </van-tabbar> -->
   
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: 0,
    };
  },

};
</script>

<style>

</style>
